export default {
  render(createElement) {
    return createElement("style", this.$slots.default);
  }
};
